var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "single_question" },
    [
      _c("div", { staticClass: "question_title" }, [
        _c("span", [
          _vm._v(
            _vm._s(
              _vm.questionData.sectionName === undefined
                ? ""
                : _vm.questionData.sectionName
            )
          )
        ]),
        _vm._v(" "),
        _c("span", [
          _vm._v(
            "(" +
              _vm._s(
                _vm.questionData.sectionPrompt +
                  "  本题" +
                  _vm.questionData.score +
                  "分。"
              ) +
              ")"
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "title" }, [
        _vm.questionData.questionContent
          ? _c("div", {
              staticClass: "editorShowArea ql-editor title_one",
              domProps: { innerHTML: _vm._s(_vm.questionData.questionContent) }
            })
          : _vm._e(),
        _vm._v(" "),
        _c("h3", {
          staticClass: "editorShowArea ql-editor",
          staticStyle: { overflow: "auto" },
          domProps: {
            innerHTML: _vm._s(_vm.questionData.questionDto.questionContent)
          }
        })
      ]),
      _vm._v(" "),
      _vm._l(_vm.questionData.questionDto.items, function(data, index) {
        return _c(
          "div",
          { staticClass: "single_item" },
          [
            _c(
              "el-checkbox",
              {
                staticClass: "single_radio",
                attrs: { disabled: _vm.disabledFlag },
                on: {
                  change: function($event) {
                    return _vm.save()
                  }
                },
                model: {
                  value: _vm.checked[index],
                  callback: function($$v) {
                    _vm.$set(_vm.checked, index, $$v)
                  },
                  expression: "checked[index]"
                }
              },
              [_vm._v(_vm._s(null))]
            ),
            _vm._v(" "),
            _c("span", {
              staticClass: "single_title editorShowArea ql-editor",
              staticStyle: { float: "left", flex: "none" },
              domProps: { innerHTML: _vm._s(data.itemKey) }
            }),
            _vm._v(" "),
            _c("span", {
              staticClass: "single_title editorShowArea ql-editor",
              domProps: { innerHTML: _vm._s(data.itemValue) }
            })
          ],
          1
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4ce12002", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ce12002","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/studyCenter/switch/testComponent/more.vue
// module id = null
// module chunks = 